<template>
  <div class="parking-complex-preview">
    <div class="parking-complex-preview__viewport">
      <div
        class="parking-complex-preview__phone"
        :class="{'parking-complex-preview__phone_map': isParkingMode}"
      >
        <div class="parking-complex-preview__status-bar">
          <strong>9:41</strong>
          <div class="parking-complex-preview__system-icons">
            <img src="@/assets/img/parkingDetection/cellular.svg" alt="">
            <img src="@/assets/img/parkingDetection/wifi.svg" alt="">
            <span class="parking-complex-preview__battery">
              <span />
              <img src="@/assets/img/parkingDetection/battery-cap.svg" alt="">
            </span>
          </div>
        </div>

        <template v-if="isParkingMode">
          <img
            class="parking-complex-preview__map-background"
            src="@/assets/img/parkingDetection/mobile-map-background.png"
            alt=""
          >

          <div class="parking-complex-preview__map-navigation">
            <span>‹ Назад</span>
            <strong>{{ parkingName }}</strong>
            <span>◎</span>
          </div>

          <div class="parking-complex-preview__map">
            <img
              class="parking-complex-preview__map-location"
              src="@/assets/img/parkingDetection/mobile-map-location.svg"
              alt=""
            >
            <ParkingMapPolygon
              class="parking-complex-preview__map-parking"
              :color="parkingColor"
            />
            <img
              class="parking-complex-preview__map-parking-pin"
              src="@/assets/img/parkingDetection/mobile-map-parking-pin.svg"
              alt=""
            >
            <span class="parking-complex-preview__map-name">{{ parkingName }}</span>
          </div>

          <div class="parking-complex-preview__parking-sheet">
            <button type="button" aria-label="Закрыть">
              ×
            </button>
            <strong>{{ parkingName }}</strong>
            <span>
              <img src="@/assets/img/parkingDetection/parking-space-counter.svg" alt="">
              <b>{{ freeSpotsCount }} из {{ totalSpotsCount }}</b>
            </span>
          </div>
        </template>

        <template v-else>
          <div class="parking-complex-preview__navigation">
            <span>Изм.</span>
            <strong>Главная</strong>
            <div>
              <img src="@/assets/img/parkingDetection/bell.svg" alt="">
              <span aria-hidden="true">＋</span>
            </div>
          </div>

          <div class="parking-complex-preview__stories">
            <div
              v-for="(story, index) in stories"
              :key="index"
              class="parking-complex-preview__story"
            >
              <img :src="story.image" alt="">
              <span>{{ story.title }}</span>
            </div>
          </div>

          <div class="parking-complex-preview__tabs">
            <img src="@/assets/img/parkingDetection/menu.svg" alt="">
            <span class="parking-complex-preview__tab parking-complex-preview__tab_active">Избранное</span>
            <span class="parking-complex-preview__tab">Дача</span>
          </div>

          <div class="parking-complex-preview__widgets">
            <div class="parking-complex-preview__parking-widget">
              <div class="parking-complex-preview__gauge">
                <img src="@/assets/img/parkingDetection/gauge-1.svg" alt="">
                <img src="@/assets/img/parkingDetection/gauge-2.svg" alt="">
                <img src="@/assets/img/parkingDetection/gauge-3.svg" alt="">
                <div class="parking-complex-preview__counter">
                  <strong>{{ freeSpotsCount }}</strong>
                  <span>Свободно<br>мест</span>
                </div>
              </div>
              <img
                class="parking-complex-preview__parking-icon"
                src="@/assets/img/parkingDetection/parking-space-counter.svg"
                alt=""
              >
              <div v-if="displayName" class="parking-complex-preview__complex-name">
                {{ displayName }}
              </div>
            </div>

            <div v-if="camera || showDemoCamera" class="parking-complex-preview__camera-widget">
              <img
                v-if="camera && camera.preview_url"
                :src="camera.preview_url"
                :alt="cameraTitle"
              >
              <img
                v-else-if="showDemoCamera"
                src="@/assets/img/parkingDetection/camera-card.png"
                alt="Демо-превью камеры"
              >
              <div v-else class="parking-complex-preview__camera-no-preview">
                Превью недоступно
              </div>
              <div class="parking-complex-preview__camera-caption">
                <strong>{{ camera ? cameraTitle : 'Обзорная камера' }}</strong>
                <span v-if="camera && camera.address">{{ camera.address }}</span>
                <span v-else-if="showDemoCamera">проспект Октября 4/3</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="parking-complex-preview__fade" />
    </div>

    <div class="parking-complex-preview__caption">
      Визуализация шаблона
    </div>
  </div>
</template>

<script>
import {PARKING_COLORS} from "@/components/pacs/analytics/parkingDetection/parkingComplexConfig.js";
import ParkingMapPolygon from "@/components/pacs/analytics/parkingDetection/ParkingMapPolygon.vue";

/**
 * Предпросмотр виджета комплекса или выбранной парковки в мобильном приложении.
 */
export default {
  name: "ParkingComplexPreview",
  components: {
    ParkingMapPolygon,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "widget",
    },
    parking: {
      type: Object,
      default: null,
    },
    parkings: {
      type: Array,
      default: () => [],
    },
    camera: {
      type: Object,
      default: null,
    },
    showDemoCamera: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stories: [
        {
          image: require("@/assets/img/parkingDetection/story-1.png"),
        },
        {
          image: require("@/assets/img/parkingDetection/story-2.png"),
        },
        {
          image: require("@/assets/img/parkingDetection/story-3.png"),
        },
        {
          image: require("@/assets/img/parkingDetection/story-4.png"),
          title: "Управляйте домофоном",
        },
      ],
    };
  },
  computed: {
    displayName() {
      return this.name.trim();
    },
    isParkingMode() {
      return this.mode === "parking" && Boolean(this.parking);
    },
    parkingName() {
      return String((this.parking && this.parking.name) || "Парковка").trim() || "Парковка";
    },
    parkingColor() {
      const color = PARKING_COLORS.find(item => item.value === (this.parking && this.parking.color));

      return color ? color.hex : PARKING_COLORS[0].hex;
    },
    previewParkings() {
      return this.isParkingMode ? [this.parking] : this.parkings;
    },
    freeSpotsCount() {
      return this.previewParkings.reduce(
        (count, parking) => count + Number(parking.free_spots_count || 0),
        0
      );
    },
    totalSpotsCount() {
      return this.previewParkings.reduce(
        (count, parking) => count + Number(parking.total_spots_count || 0),
        0
      );
    },
    cameraTitle() {
      return (this.camera && (this.camera.title || this.camera.camera_number)) || "Камера";
    },
  },
};
</script>
